/****************************************************
 * Module Name:  addStoneLabstatusModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { Component } from "react";
import { Form } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import StoneLabstatusProxy from "../../utility/proxy/manager/stoneLabStatusProxy";
import Constants from "../../utility/constants";
import CircularProgress from "@mui/material/CircularProgress";
import "bootstrap/dist/css/bootstrap.min.css";
import Utility from "../../utility/utility";
import { Box, Button, TextField } from "@mui/material";
import logo from '../../images/pansuriya.jpg'
import CommonSnackbar from "../common/commonSnackBar";
import { LoadingButton } from "@mui/lab";
import SaveIcon from '@mui/icons-material/Save';

export default class AddStoneLabstatusModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      newstatus: this.props.editOperation ? this.props.sourceData.status : "",
      newdescription: this.props.editOperation
        ? this.props.sourceData.description
        : "",

      showError: false,

      validateStoneLabstatusPresentSpinner: false,
      showValidationMessage: false,
      stoneLabstatusAvailable: true,

      statusValidationError: "",
    };
  }

  handleSave = () => {
    let data = {
      id: this.props.editOperation ? this.props.sourceData.id : undefined,
      status: this.state.newstatus,
      description: this.state.newdescription,
    };

    if (this.props.handleSave) {
      if (this.props.handleValidation) {
        if (this.props.handleValidation(data)) this.props.handleSave(data);
        else
          this.setState({
            showError: true,
          });
      } else this.props.handleSave(data);
    }
  };

  closeErrorDialog = () => {
    this.setState({
      showError: false,
    });
  };

  validateStoneLabstatusPresent = (stoneLabstatusEntered) => {
    if (!stoneLabstatusEntered || stoneLabstatusEntered.trim() === "") return;

    this.setState({
      validateStoneLabstatusPresentSpinner: true,
    });

    StoneLabstatusProxy.CheckStoneLabstatusAvailable(
      stoneLabstatusEntered,
      (response) => {
        //if we got response that means stonestatus is present at backend
        if (response) {
          //Stone Status already present
          this.setState({
            validateStoneLabstatusPresentSpinner: false,
            showValidationMessage: true,
            stoneLabstatusAvailable: false,
          });
        } else {
          //Stone Status not available, so can be used
          this.setState({
            validateStoneLabstatusPresentSpinner: false,
            showValidationMessage: true,
            stoneLabstatusAvailable: true,
          });
        }
      }
    );
  };

  buttonDisable = () => {
    if (!this.props.editOperation)
      return (
        !this.state.showValidationMessage || !this.state.stoneLabstatusAvailable
      );

    return false;
  };

  render() {
    return (
      <Box>
        <CommonSnackbar
          show={this.state.showError}
          message={
            <Box>
              Add stone lab validation Failed
              <br /> Please enter complete data
            </Box>
          }
          variant={"error"}
          autoHide={false}
          handleClose={this.closeErrorDialog}
          title="Validation Failure"
        />

        <Modal backdrop="static" show={this.props.Show} onHide={this.props.handleClose} enforceFocus={false}>
          <Modal.Header closeButton>
            <Modal.Title>
              <img
                src={logo}
                height="40pt"
                width="40pt"
                alt={Constants.COMPANY_SITE}
              />
              &nbsp;&nbsp;
              {this.props.editOperation
                ? "Edit Stone Lab Status"
                : "Add New Stone Lab Status"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <center>
              <table style={{ width: "100%" }}>
                <tbody>
                  {this.props.editOperation && (
                    <tr>
                      <td>
                        <Form.Label>Stone Lab Status Id</Form.Label>
                      </td>
                      <td>
                        <Form.Label>{this.props.sourceData.id}</Form.Label>
                      </td>
                    </tr>
                  )}
                  {this.props.editOperation && (
                    <tr>
                      <td>&nbsp;</td>
                    </tr>
                  )}
                  <tr>
                    <td>
                      <Form.Label>
                        Stone Lab Status <sup style={{ color: "red" }}>*</sup>
                      </Form.Label>
                    </td>
                    {this.props.editOperation ? (
                      <td>
                        <Form.Label>{this.state.newstatus}</Form.Label>
                      </td>
                    ) : (
                      <td>
                        <TextField
                          margin="normal"
                          fullWidth
                          size="small"
                          label="Stone Lab Status (required)"
                          placeholder="Enter Stone Lab Status"
                          value={this.state.newstatus}
                          autoFocus
                          onBlur={(e) =>
                            this.validateStoneLabstatusPresent(
                              this.state.newstatus
                            )
                          }
                          onChange={(e) =>
                            this.setState({
                              newstatus: e.target.value,
                              showValidationMessage: false,
                              statusValidationError: Utility.CheckIsPresent(
                                e.target.value
                              )
                                ? ""
                                : "Stone Lab Status Cannot be Empty",
                            })
                          }
                          helperText={this.state.statusValidationError}
                          error={this.state.statusValidationError.length > 0}
                        />
                      </td>
                    )}
                  </tr>
                  <tr>
                    <td></td>
                    <td>
                      {this.state.validateStoneLabstatusPresentSpinner ? (
                        <CircularProgress size="1rem" />
                      ) : !this.state.showValidationMessage ? (
                        <Box>&nbsp;</Box>
                      ) : this.state.stoneLabstatusAvailable ? (
                        <font color="green">Stone Lab Status available</font>
                      ) : (
                        <font color="red">Stone Lab Status not available</font>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>Description</Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        size="small"
                        label="Description"
                        placeholder="Enter Description"
                        value={this.state.newdescription}
                        onChange={(e) =>
                          this.setState({ newdescription: e.target.value })
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                  </tr>
                </tbody>
              </table>
            </center>
          </Modal.Body>
          <Modal.Footer>
            <LoadingButton
              loading={this.props.loading}
              loadingPosition="start"
              startIcon={<SaveIcon />}
              variant="contained"
              onClick={() => this.handleSave()}
              disabled={this.buttonDisable()}
              sx={{ mr: 1 }}
            >
              Save
            </LoadingButton>
            <Button
              variant="contained"
              color="error"
              onClick={this.props.handleClose}
              disabled={this.props.loading}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </Box>
    );
  }
}
